import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { SIDE_BET_TARGET_ANIMATION_SET } from '../../animations/animationDefinitions';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../constants/constants';
import { useAppSelector } from '../../redux/store';
import { SIDE_BETS_ACCENT_COLOR_NUM } from '../../styles/colors';
import { isTestEnvironment } from '../../utils/utils';
import { AnimationContainer } from './pixiComponents/animationContainer';
import { Rect } from './pixiComponents/rect';
const PADDING_PX = 1;
export const SideBetTargetBackground = ({ seatIndex, startTimestampMs }) => {
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    if (bounds === undefined) {
        return null;
    }
    const w = bounds.w - 2 * PADDING_PX;
    const h = bounds.h - 2 * PADDING_PX;
    return (_jsx(Container, { "pixi-data": isTestEnvironment() ? { type: 'side-bet-target-background', seatIndex } : null, interactiveChildren: false, x: bounds.x, y: bounds.y, children: _jsx(AnimationContainer, { startTimestampMs: startTimestampMs, animationSet: SIDE_BET_TARGET_ANIMATION_SET, children: _jsx(Rect, { x: -w / 2, y: -h / 2, w: w, h: h, lineColor: SIDE_BETS_ACCENT_COLOR_NUM, lineWidth: 6, radius: POKER_SEAT_ROUNDED_RECT_RADIUS, fillColor: SIDE_BETS_ACCENT_COLOR_NUM, fillAlpha: 0.3 }) }) }));
};
